import { Component, Input } from '@angular/core';
import { StoreConfigService } from '@scalefast/config-angular';
import { CustomerService, LoginService } from '@scalefast/ecommerce-core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppLoginButtonTemplateComponent } from './login-button-template/login-button-template.component';

@Component({
  selector: 'app-login-button',
  template: `<app-login-button-template
    [showAssociatedText]="showAssociatedText"
    [isUserLoggedIn]="isLogged$"
    [accountUrl]="accountUrl"
    [loginUrl]="loginUrl"
    [userName]="userName"
  />`,
  standalone: true,
  imports: [AppLoginButtonTemplateComponent],
})
export class AppLoginButtonComponent {
  @Input() showAssociatedText: boolean = false;
  private userName$ = new BehaviorSubject('');
  accountUrl: string;
  loginUrl: string;
  isLogged$: Observable<boolean>;
  userName: Observable<string>;

  constructor(
    public loginService: LoginService,
    private storeConfigService: StoreConfigService,
    private customerService: CustomerService,
  ) {
    this.accountUrl = storeConfigService.getCustomRoutes()?.account ?? 'account';
    this.loginUrl = storeConfigService.getCustomRoutes()?.login ?? 'sso_login';
    this.isLogged$ = this.loginService.isLogged();
    // FIXME: Instead subscribing to isLogged, we should subscribe correctly to the credentials observable in getCustomerUseCase.

    this.isLogged$.subscribe((state) => {
      if (state) {
        this.customerService.getCustomer$().subscribe((customer) => this.userName$.next(customer.userName || customer.firstName));
      }
    });
    this.userName = this.userName$;
  }
}
